import { render, staticRenderFns } from "./setEmail.vue?vue&type=template&id=0b9c32f7&scoped=true&"
import script from "./setEmail.vue?vue&type=script&lang=js&"
export * from "./setEmail.vue?vue&type=script&lang=js&"
import style0 from "./setEmail.vue?vue&type=style&index=0&id=0b9c32f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9c32f7",
  null
  
)

export default component.exports